import { render } from "./SendButton.vue?vue&type=template&id=661d598f&scoped=true&bindings={}"
import script from "./SendButton.vue?vue&type=script&lang=ts"
export * from "./SendButton.vue?vue&type=script&lang=ts"

import "./SendButton.vue?vue&type=style&index=0&id=661d598f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-661d598f"

export default script